import Box from '@mui/material/Box';
import { Status, ThinkingStatusIcon } from './components/ThinkingStatusIcon.tsx';
import { messageRowSx } from './styles.ts';

export type ChatThinkingContentProps = {
  thinkingProcessMessages?: readonly string[];
};

export const ChatThinkingContent = ({ thinkingProcessMessages = [] }: ChatThinkingContentProps) => {
  return (
    <>
      {thinkingProcessMessages.map((message, index) => (
        <Box key={message} sx={messageRowSx}>
          <ThinkingStatusIcon
            status={index < thinkingProcessMessages.length - 1 ? Status.SUCCESS : Status.LOADING}
            message={message}
          />
        </Box>
      ))}
    </>
  );
};
